import React from 'react';

const MyServices = () => {
  return (
    <div className="services-wrapper">
      <div className="services-icons">
        <img src="https://img.icons8.com/ios/2x/pin.png" alt="" />
        <img
          src="https://img.icons8.com/windows/344/project-diagram.png"
          alt=""
        />
        <img src="https://img.icons8.com/ios/2x/code.png" alt="" />
        <img
          src="https://img.icons8.com/external-tanah-basah-detailed-outline-tanah-basah/2x/external-desktop-user-interface-tanah-basah-detailed-outline-tanah-basah.png"
          alt=""
        />
      </div>
      <div className="services-msg">
        <div className="title">
          <h2>My Services</h2>
          <div className="line"></div>
        </div>
        <div className="msg">
          <p>
            I dedicate myself to presenting my clients with completed projects
            that not only meet, but exceed, their initial vision. Knowing what
            to expect when we work together is critical - here is how I deliver
            success:
          </p>
          <ol>
            <li>
              <strong className="bold">Consultation</strong> - It all begins
              with a conversation where we'll pinpoint what this project is all
              about.
            </li>
            <li>
              <strong className="bold">Proposal </strong> - A detailed project
              proposal including a visual preview will be presented and a plan
              of action will be decided.
            </li>
            <li>
              <strong className="bold">Creation</strong> - Clients receive
              regular updates regarding their project status while I create and
              test it.
            </li>
            <li>
              <strong className="bold">Launch & Support</strong> - Peace of mind
              is delivered with the final project in the form of available
              ongoing support.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default MyServices;
